module.exports = __webpack_public_path__ + "df19031d59cecd5202a7a2057c8aadad.ttf";